import PrimaryButton from '../common-components/component-library/buttons/PrimaryButton';
import PageHero from '../common-components/component-library/heroes/PageHero';
import FormCTA from '../common-components/component-library/layout/FormCTA';
import Highlight from '../utils/templatePages/Highlight';
import QuestionsAndAnswers from '../common-components/component-library/layout/accordionLayout/QuestionsAndAnswers';
import { colors } from '../utils/styleguide';
import { Document } from '@contentful/rich-text-types';

export type PlainTextPageProps = {
  isPlainTextPage: boolean;
  heroSectionTitle?: string;
  heroParagraph?: string;
  heroCTAs?: { label?: string; href?: string }[];
  mainContent: {
    sectionTitle?: string;
    text?: Document;
  };
  faqSectionTitle?: string;
  faqTitle?: string;
  faqPreamble?: string;
  faqSectionReferences?: {
    title?: string;
    description?: Document;
  }[];
  contactUsSectionTitle?: string;
  contactUsTitle?: string;
  contactUsSections?: Array<
    Partial<{
      title: string;
      description: Document;
      link: Partial<{
        title: string;
        url: string;
      }>;
    }>
  >;
};

export function PlainTextPageLayout(props: PlainTextPageProps) {
  const {
    heroSectionTitle,
    heroParagraph,
    heroCTAs,
    mainContent,
    faqSectionTitle,
    faqTitle,
    faqPreamble,
    faqSectionReferences,
    contactUsSectionTitle,
    contactUsTitle,
    contactUsSections,
  } = props;

  return (
    <>
      <PageHero title={heroSectionTitle} preamble={heroParagraph}>
        {heroCTAs?.map((cta, index) => (
          <PrimaryButton
            key={index}
            label={cta.label}
            href={cta.href}
            replace={false}
            color="purple"
            variant={index === 0 ? 'solid' : 'outline'}
          />
        ))}
      </PageHero>
      <Highlight {...mainContent} backgroundColor={colors.grey50} withCheckmark={false} />
      <QuestionsAndAnswers
        sectionTitle={faqSectionTitle}
        title={faqTitle}
        preamble={faqPreamble}
        faqSectionReferences={faqSectionReferences}
        backgroundColor={colors.white}
      />
      <FormCTA
        ctaFormSectionTitle={contactUsSectionTitle}
        ctaFormTitle={contactUsTitle}
        ctaFormSections={contactUsSections}
        backgroundColor={colors.grey50}
      />
    </>
  );
}
